import { ColumnDetails } from '../../../../grid/types/common';
import { Column } from '@nirvana/shared/dtos/types/shared/filters';
import { ColumnKeys } from '@nirvana/shared/dtos/types/alerts/common';
import { gridCustomHtmlRenderer } from '../../../../grid/utils/renderers';
import { htmlEncode } from '../../../../utils/escape.utils';
import { getIntegrityMonitorChangesNames } from '../types';
import { capitalize } from '@nirvana/shared/common';
import { GzButtonWebComponent } from '../../../../ui/gzButton';
import { ButtonColors, ButtonHeights, ButtonTypes } from '../../../../ui/gzButton/types';
import { handleClickOnEndpoint } from '../../../../../../../libs/shared/common/src/lib/eventHandlers';
import { isEmpty } from '@nirvana/shared/basic-types/object';

export function integrityMonitorEndpointRenderer(rowData, columnDetails: ColumnDetails<any, any>) {
  let cellValue = rowData.item[columnDetails.key];
  let buttonDisabled = false;
  let buttonColor = ButtonColors.PRIMARY;

  if (!cellValue) {
    cellValue = rowData.item['hostname'] || this.dependencies.translateFn('Unknown endpoint');

    buttonDisabled = true;
    buttonColor = ButtonColors.SECONDARY;
  }

  const button = document.createElement('gz-button') as GzButtonWebComponent;
  button.type = ButtonTypes.QUIET;
  button.buttonHeight = ButtonHeights.SMALL;
  button.innerText = cellValue;
  button.disabled = buttonDisabled;
  button.color = buttonColor;
  button.lowercase = true;

  if (!isEmpty(rowData.item['endpoint_id'])) {
    button.setAttribute('data-endpoint-id', rowData.item['endpoint_id']);
    button.addEventListener('click', handleClickOnEndpoint.bind(this));
  }

  return button;
}

export function integrityMonitorChangesRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  const cellValue = rowData.item[columnDetails.key];
  const changesNames = getIntegrityMonitorChangesNames(this.dependencies.translateFn);
  const changedAttributes = Object.keys(cellValue).map(elem => changesNames[elem] || elem);
  const displayedString = capitalize(changedAttributes.join(', '));

  return gridCustomHtmlRenderer(`<span class='cell-label'>${htmlEncode(displayedString)}</span>`);
}
